import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { initStep4Data } from '../../ultis/objects/SignUp';
import { validateEmail, validateName, validatePhone } from '../../ultis/regex/Regex';
import { useDispatch, useSelector } from 'react-redux'
import { nextStep4 } from '../../redux/creates-action/SignUpAction';
import { verifyEmail } from '../../services/SignUp';

export default function Step4() {
  const [values, setValues] = useState(initStep4Data('', '', '', ''))
  const [phoneErrorText, setPhoneErrorText] = useState('')
  const [emailErrorText, setEmailErrorText] = useState('')
  const [fullNameErrorText, setFullNameErrorText] = useState('')
  const dispatch = useDispatch()
  const data4 = useSelector(state => state.signup.data.companyRep)

  useEffect(() => {
    if (values.phone !== '' && values.fullName !== '' && values.email !== '' && values.address !== '' && !values.isPhoneError && !values.isFullNameError && !values.isEmailError) {
      dispatch(nextStep4(values.fullName, values.phone, values.email, values.address))
    }
  }, [values.fullName, values.phone, values.email, values.address, dispatch])

  useEffect(() => {
    let data = {
      ...values,
      fullName: data4.fullName,
      phone: data4.phone,
      email: data4.email,
      address: data4.address
    };
    setValues(data);
  }, [data4.fullname, data4.phone, data4.email, data4.address])

  const handleFullNameChange = (event) => {
    let value = event.target.value;
    let data = handleValidateFullName(value);
    setValues(data);
  }

  const handlePhoneChange = (event) => {
    let value = event.target.value;
    let data = handleValidatePhone(value);
    setValues(data);
  }

  const handleEmailChange = async (event) => {
    let value = event.target.value;
    let data = await handleValidateEmail(value);
    setValues(data);

  }

  const handleAddressChange = (event) => {
    let value = event.target.value;
    let data = { ...values, address: value };
    setValues(data);

  }

  function handleValidateFullName(fullName) {
    let result = validateName(fullName);
    let data;
    if (!result) {
      data = { ...values, fullName: fullName, isFullNameError: true };
      setValues(data);
      setFullNameErrorText("Fullname does not include characters other than text");
    } else {
      data = { ...values, fullName: fullName, isFullNameError: false };
      setValues(data);
      setFullNameErrorText("");
    }
    return data;
  }


  function handleValidatePhone(phone) {
    let result = validatePhone(phone);
    let data;
    if (!result) {
      data = { ...values, phone: phone, isPhoneError: true };
      setValues(data);
      setPhoneErrorText(" Phone must contain 10 characters");
    } else {
      data = { ...values, phone: phone, isPhoneError: false };
      setValues(data);
      setPhoneErrorText("");
    }
    return data;
  }

  async function handleValidateEmail(email) {
    let result = validateEmail(email);
    let data;
    data = { ...values, email: email, isEmailError: !result };
    if (!result) {
      setEmailErrorText("Email address is invalid");
    } else {
      const result = await verifyEmail({ email: email })
      data = { ...data, isEmailError: result.isExist };
      if (result.isExist === true) {
        setEmailErrorText("Email address is Exist");
      }
      else setEmailErrorText("");
    }
    return data;
  }

  return (
    <React.Fragment>
      <p style={{ textAlign: 'center', margin: '24px 0 48px 0', fontWeight: '500', fontSize: '20px', color: '#212529', fontFamily: 'Jost, sans-serif', }}>
        {/* Enter company representative for sign-up */}
      </p>
      <Grid container spacing={3} sx={{ paddingRight: 2 }}>
        <Grid item xs={12} sm={4} md={12}>
          <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif', }} >FullName *</label>
          <TextField fullWidth variant='outlined' value={values.fullName} onChange={handleFullNameChange} error={values.isFullNameError} helperText={fullNameErrorText} />
        </Grid>
        <Grid item xs={12} sm={4} md={6}>
          <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif', }} >Phone *</label>
          <TextField fullWidth variant='outlined' value={values.phone} onChange={handlePhoneChange} error={values.isPhoneError} helperText={phoneErrorText} />
        </Grid>
        <Grid item xs={12} sm={4} md={6}>
          <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif', }} >Email *</label>
          <TextField fullWidth variant='outlined' value={values.email} onChange={handleEmailChange} error={values.isEmailError} helperText={emailErrorText} />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif', }} >Address *</label>
          <TextField fullWidth variant='outlined' value={values.address} onChange={handleAddressChange} ></TextField>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}